<script lang="ts">
    import { apiBaseOverride } from "../../store"
    import MedialibImage from "../MedialibImage.svelte"

    export let apiBase: string = null
    if (apiBase) {
        $apiBaseOverride = apiBase
    }

    export let slide: BlockHeroSlide
</script>

<!-- is admin view or not hidden -->
{#if apiBase || !slide.hide}
    <div class="slide" class:hidden="{!!slide.hide}">
        {#if slide.backgroundImage}
            <div class="background-image {slide.darkenBackground ? 'darken-background' : ''}">
                <figure>
                    <MedialibImage id="{slide.backgroundImage}" />
                    <!-- Wir kriegen für alle Slides ein Hintergrundbild und ein Content-Bild (s.u.) -->
                </figure>
            </div>
        {/if}
        <div class="container{slide.imageBleed ? '-' + slide.imagePosition : ''}">
            <div class="grid" class:direction-row-reverse="{slide.imagePosition == 'left'}">
                <!-- direction-row-reverse für Bild Links Text rechts, ansonsten weglassen -->
                <div
                    class="col-md-5 slide-content gap-xl vp-xl align-self-{slide.textVerticalPosition} {slide.textColor
                        ? 'white-text'
                        : ''}"
                >
                    {#if slide.headline}
                        <h2 class="h1 {slide.iconClass ? 'icon ' + slide.iconClass : ''}">
                            {slide.headline}
                        </h2>
                    {/if}
                    <!-- Klasse orienteering stellt das Icon links daneben dar, hier soll die Kategorie hin -->
                    <div class="copy">
                        {@html slide.text}
                    </div>
                    {#if slide.callToAction?.buttonText}
                        <div class="button-wrap">
                            <a
                                href="{slide.callToAction.buttonLink}"
                                class="cta btn-primary"
                                target="{slide.callToAction.buttonTarget || undefined}"
                                >{slide.callToAction.buttonText}</a
                            >
                        </div>
                    {/if}
                </div>
                {#if slide.image}
                    <div
                        class="col-md-7 align-self-{slide.imageVerticalPosition} justify-self-end {slide.imageBleed
                            ? 'col-bleed'
                            : 'col-bleed-y'}"
                    >
                        <figure>
                            <MedialibImage id="{slide.image}" />
                        </figure>
                    </div>
                {/if}
            </div>
        </div>
    </div>
{/if}

<style lang="less">
    .hidden {
        opacity: 0.5 !important;
        filter: grayscale(100%);
    }

    .hero.in-view {
        transition: unset;
        transform: unset;
        opacity: 1;

        :global {
            .slide .container .grid {
                div:first-of-type {
                    transition: unset;
                    transform: unset;
                    &.icon {
                        transform: unset;
                    }
                }
                div:last-of-type {
                    transition: unset;
                    transform: unset;
                }
            }
        }
    }

    .hero.not-in-view {
        transition: unset;
        transform: unset;
        opacity: 1;
        :global {
            .slide .container .grid {
                div:first-of-type {
                    transform: unset;
                    &.icon {
                        transform: unset;
                    }
                }
                div:last-of-type {
                    transform: unset;
                }
            }
        }
    }
</style>
